export const environment = {
  production: true,
  dbUrl: 'https://data.4zzz.org.au',
  musicDBapiSrc: 'https://data.4zzz.org.au/musicDB',
  apiSrc: 'https://data.4zzz.org.au/zeddb'
};
